import { type FC } from 'react';
import { type IBranch } from '../../../../types/branch';

interface Props {
    branch: IBranch
    onClick: (branch: IBranch) => void
}

const BranchItem: FC<Props> = ({ branch, onClick }) => (
    <button
        onClick={() => onClick(branch)}
        type="button"
        className="group relative w-full h-64 sm:h-80 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 ease-out"
    >
        {/* Background Image with Zoom Effect */}
        <div className="absolute inset-0 w-full h-full overflow-hidden">
            <img
                src={branch.image}
                alt={branch.name}
                className="w-full h-full object-cover transform transition-transform duration-700 ease-out group-hover:scale-110"
            />
            {/* Gradient Overlay for Text Readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500"></div>
        </div>

        {/* Content Container */}
        <div className="absolute inset-0 p-6 flex flex-col justify-end items-start text-left">
            {/* Branch Name */}
            <h3 className="text-2xl font-bold text-white mb-2 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500 line-clamp-2">
                {branch.name}
            </h3>

            {/* Decorative Line */}
            <div className="w-12 h-1 bg-indigo-500 rounded-full mb-4 transform scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500 delay-100"></div>

            {/* Action Button (Hidden by default, slides up on hover) */}
            <div className="overflow-hidden h-0 group-hover:h-auto opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                <div className="flex items-center gap-2 text-indigo-300 font-medium text-sm transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <span>Acceder a la oposición</span>
                    <svg
                        className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </div>
            </div>
        </div>

        {/* Top Right Badge (Optional - could be used for status or tags later) */}
        <div className="absolute top-4 right-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform translate-y-[-10px] group-hover:translate-y-0">
            <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
        </div>
    </button>
);

export { BranchItem };
